import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, EventEmitter, inject, Inject, Input, OnInit, Output, PLATFORM_ID, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ObjFilter } from '@app/components/tools/ObjFilter';
import { Customer } from '@app/models/customers/Customer';
import { OffersFilters } from '@app/models/filtermodels/OffersFilters';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { OffersResponse } from '@app/models/offers/OffersResponse';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { AuthService } from '@app/services/auth.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { TrafficsService } from '@app/services/traffics.service';
import { ObjFilterPeakwork } from '@app/components/tools/ObjFilterPeakwork';
import { PeakworkService } from '@app/services/peakwork.service';
import { forkJoin } from 'rxjs';
@Component({
    selector: 'clever-hotelextrafilter',
    templateUrl: './hotelfilter.component.html',
    styleUrls: ['./hotelfilter.component.scss'],
    standalone: false
})
export class HotelExtrafFilterComponent implements OnInit {
    @Input() mode: string;
    @Input() type: string;
    @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
    filtersStaticData: OffersFilters;
    tmp_filtersStaticData: OffersFilters;
    isBrowser = signal<boolean>(false);
    loading = signal<boolean>(true);
    flexfromtraffics: string = '0';
    media: string = 'lg';
    realparams: ParamFilters;
    tourOperatorList: any;
    partner: Partner;
    destroyRef = inject(DestroyRef);
    tmp_stat: OffersResponse;
    currentCustomer: Customer;

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected trafficsService: TrafficsService,
        protected guardService: AuthGuardService,
        protected peakworkservie: PeakworkService,
        protected authService: AuthService,
        protected hotelService: HotelFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        if (this.isBrowser()) {
            this.initMedia();
            this.initPartnerSub();
            this.initAuth();
        }
    }

    async initAuth() {
        this.authService.auth$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((customer: Customer) => {
            if (customer?.email?.length > 0) {
                this.currentCustomer = customer;
                this.cdr.detectChanges();
            }
        });
    }

    initPartnerSub(): void {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(partner => {
            if (partner?.partnerid?.length > 0) {
                this.partner = partner;
                this.cdr.detectChanges();
                this.initFilters();
            }
        });
    }

    initFilters(): void {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe(params => {
            if (params && JSON.stringify(params) !== JSON.stringify(this.realparams)) {
                this.realparams = JSON.parse(JSON.stringify(params));
                if (this.partner.traffics.aktiv) {
                    this.initFilter();
                } else if (this.partner.peakwork.active) {
                    this.getStaticPeakworkData();
                }
            }
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
    }

    async closeextras() {
        this.closeModal.emit(true);
    }

    async resetAll() {
        this.hotelService.resetAllExtrasHome();
    }

    initFilter(): void {
        this.filtersStaticData = new ObjFilter(this.realparams, 1000, this.partner.agenturen).initExtraFilters();
        this.getStaticData();
    }

    async getStaticData() {
        let target = 'offers';
        // console.log(this.mode)
        switch (this.mode) {
            case 'topregions':
                target = 'regions';
                break;
            case 'hotels':
                target = 'hotels';
                break;

            default:
                target = 'offers';
                break;
        }
        if (JSON.stringify(this.filtersStaticData) !== JSON.stringify(this.tmp_filtersStaticData)) {
            this.tmp_filtersStaticData = JSON.parse(JSON.stringify(this.filtersStaticData));
            if (target === 'offers') {
                this.filtersStaticData.optionLists = 'flightCarrier,hotelChain,roomType,boardType,roomId,arrivalAirport,departureAirport,tourOperator,inclusiveCode';
            }
            // console.log(this.filtersStaticData)
            this.trafficsService.request(this.filtersStaticData, target).pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe(obj => {
                this.tmp_stat = obj;
                // console.log(obj)
                // let found = false
                // for (let i = 0; i < obj?.inclusiveCodeList?.length; i++) {
                //     if (
                //         obj.inclusiveCodeList[i].code === 'CS' ||
                //         obj.inclusiveCodeList[i].code === 'FS' ||
                //         obj.inclusiveCodeList[i].code === 'CR'
                //     ) {
                //         found = true;
                //         i = obj.inclusiveCodeList.length;
                //     }
                // }
                // this.flexfromtraffics = found ? '0' : '1';
                this.tourOperatorList = obj?.tourOperatorList;
                this.loading.set(false);
                this.cdr.detectChanges();
            });
        }
    }

    async getStaticPeakworkData() {
        let target = 'offers';
        switch (this.mode) {
            case 'topregions':
                target = 'regions';
                break;
            case 'hotels':
                target = 'hotels';
                break;

            default:
                target = 'offers';
                break;
        }
        if (target === 'offers') {
            const peakfilterroom = new ObjFilterPeakwork(this.partner, 200, this.realparams).getFilter('calendar');
            peakfilterroom.variants = ['ROOM_CODE'];
            peakfilterroom.paging.sortingOrder.order = 'START_DATE_ASC';
            const peakfilterboard = new ObjFilterPeakwork(this.partner, 200, this.realparams).getFilter('calendar');
            peakfilterboard.variants = ['BOARD_CODE'];
            peakfilterboard.paging.sortingOrder.order = 'START_DATE_ASC';
            // const peakfilterbrand = new ObjFilterPeakwork(this.partner, 200, this.realparams).getFilter('calendar');
            // peakfilterbrand.variants = ['TOUR_OPERATOR'];
            // peakfilterbrand.paging.sortingOrder.order = 'START_DATE_ASC';

            const obs: any = {
                peakfilterroom: this.peakworkservie.request({ filter: peakfilterroom, productType: this.realparams.productType }, 'getvariant'),
                peakfilterboard: this.peakworkservie.request({ filter: peakfilterboard, productType: this.realparams.productType }, 'getvariant'),
                // peakfilterbrand: this.peakworkservie.request({ filter: peakfilterbrand, productType: this.realparams.productType }, 'getvariant')
            };
            forkJoin(obs).pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe((res: any) => {
                this.setCombiPeakwork(res);
            });
        } else {
            this.loading.set(false);
            this.cdr.detectChanges();
        }
    }

    async setCombiPeakwork(res) {
        // console.log(res)
        const tmpboard = [];
        for (let i = 0; i < res?.peakfilterboard?.hotels?.[0]?.offers?.length; i++) {
            if (res?.peakfilterboard.hotels[0].offers[i]?.accommodation?.rooms?.[0]) {
                tmpboard.push({
                    code: res.peakfilterboard.hotels[0].offers[i].accommodation?.rooms?.[0]?.boardTypes?.[0],
                    name: res.peakfilterboard.hotels[0].offers[i].accommodation?.rooms?.[0]?.board,
                    bestPricePerPerson: {
                        value: Number(Number(res.peakfilterboard.hotels[0].offers[i]?.price?.perPersonAmount).toFixed(0)),
                        currency: this.guardService.getPartnerCurrency(),

                    }
                });
            }
        }
        const tmproom = [];
        for (let i = 0; i < res?.peakfilterroom?.hotels?.[0]?.offers?.length; i++) {
            if (res.peakfilterroom.hotels[0].offers[i]?.accommodation?.rooms?.[0]) {
                tmproom.push({
                    code: res.peakfilterroom.hotels[0].offers[i].accommodation?.rooms?.[0]?.types?.[0],
                    name: res.peakfilterroom.hotels[0].offers[i].accommodation?.rooms?.[0]?.description,
                    bestPricePerPerson: {
                        value:  Number(Number(res.peakfilterroom.hotels[0].offers[i]?.price?.perPersonAmount).toFixed(0)),
                        currency: this.guardService.getPartnerCurrency(),

                    }
                });
            }
        }
        this.tmp_stat = {} as OffersResponse;
        if (tmpboard?.length > 0) {
            this.tmp_stat.boardTypeList = tmpboard;
        }
        if (tmproom?.length > 0) {
            this.tmp_stat.roomTypeList = tmproom;
        }
        // console.log(this.tmp_stat);
        this.loading.set(false);
        this.cdr.detectChanges();
    }
}
